import React, { Component } from 'react';
import AnswerContainer from '../components/AnswerContainer';
import Icon from '../components/Icon';

class Question extends Component {


    render(){
        var cssClass = 'isg_panel isg_question isg_bg_base' + (this.props.enabled ? ' isg_question_current' : ' isg_question_disabled');

        return(
            <div className={cssClass}>
                <div className="isg_question_content">
                    <div className="isg_question_answers">
                        <div className="isg_question_title">{this.props.question}</div>
                        <AnswerContainer
                            answerList={this.props.answerList}
                            questionIndex={this.props.questionIndex}
                            handleAnswerSelected={this.props.handleAnswerSelected}
                            enabled={this.props.enabled}
                            currentAnswer={this.props.currentAnswer}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

Question.propTypes = {
    question: React.PropTypes.string.isRequired,
    answerList: React.PropTypes.array.isRequired,
    thematique: React.PropTypes.object.isRequired,
    questionIndex: React.PropTypes.number.isRequired,
    handleAnswerSelected: React.PropTypes.func.isRequired,
    enabled: React.PropTypes.bool.isRequired,
    currentAnswer: React.PropTypes.number
};

export default Question;


/** WEBPACK FOOTER **
 ** ./src/components/Question.js
 **/